import { render, staticRenderFns } from "./mypage-vaccount-view.vue?vue&type=template&id=570cae37&"
import script from "./mypage-vaccount-view.vue?vue&type=script&lang=js&"
export * from "./mypage-vaccount-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports